export const cardClass =
  'rounded-2xl shadow-xl border shadow-slate-200 bg-white relative overflow-hidden border-slate-100 p-5 flex flex-col';
export const textLight = 'text-slate-500';
